import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "assets/css/default.css";

import IndicadoresLayout from "layouts/Indicadores.js";
import SetupLayout from "layouts/Setup.js";
import AuthLayout from "layouts/Auth.js";

const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/indicadores" render={(props) => <IndicadoresLayout {...props} />} />
      <Route path="/setup" render={(props) => <SetupLayout {...props} />} />
      <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
      <Redirect to="/auth/login" />
    </Switch>
  </Router>,
  document.getElementById("root")
);
